import { render, staticRenderFns } from "./RAModulePlugin.vue?vue&type=template&id=6b184f1c&"
import script from "./RAModulePlugin.vue?vue&type=script&lang=js&"
export * from "./RAModulePlugin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports